import React, { useEffect, useState } from "react";
// import { supabase } from "../../../supabaseClient";
import supabase from "../../../supabaseClient";
import { FiTrash2, FiEdit } from "react-icons/fi";

export default function TestimonialsCMS() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [designation, setDesignation] = useState("");
  const [feedback, setFeedback] = useState("");
  const [avatarFile, setAvatarFile] = useState(null);
  const [editId, setEditId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  async function fetchTestimonials() {
    const { data } = await supabase
      .from("testimonials")
      .select("*")
      .order("created_at", { ascending: false });
    setItems(data || []);
  }

  useEffect(() => {
    fetchTestimonials();
  }, []);

  async function uploadAvatar() {
    if (!avatarFile) return null;
    const filename = `t-${Date.now()}-${avatarFile.name}`;
    const { error } = await supabase.storage
      .from("testimonials")
      .upload(filename, avatarFile);

    if (error) return null;
    return supabase.storage.from("testimonials").getPublicUrl(filename).data
      .publicUrl;
  }

  async function handleSave() {
    const avatar_url = await uploadAvatar();

    const payload = {
      name,
      designation,
      feedback,
      ...(avatar_url && { avatar_url: avatar_url }),
    };

    if (editId) {
      await supabase.from("testimonials").update(payload).eq("id", editId);
    } else {
      await supabase.from("testimonials").insert([payload]);
    }

    closeForm();
    fetchTestimonials();
  }

  function handleEdit(item) {
    setEditId(item.id);
    setName(item.name);
    setDesignation(item.designation);
    setFeedback(item.feedback);
    setShowModal(true);
  }

  async function handleDelete(id, avatar_url) {
    console.log("DELETE CLICKED", { id, avatar_url });

    if (!window.confirm("Delete testimonial?")) return;

    // 1️⃣ Delete Image from Storage
    if (avatar_url) {
      const url = new URL(avatar_url);
      const fullPath = decodeURIComponent(
        url.pathname.replace("/storage/v1/object/public/", "")
      );
      const path = fullPath.split("/").slice(1).join("/");

      console.log("DELETE STORAGE PATH ->", path);

      const { error: storageErr } = await supabase.storage
        .from("testimonials")
        .remove([path]);

      console.log("STORAGE DELETE ERROR ->", storageErr);
    }

    // 2️⃣ Delete row from DB
    const { error: dbErr } = await supabase
      .from("testimonials")
      .delete()
      .eq("id", id);

    console.log("DB DELETE ERROR ->", dbErr);

    // 3️⃣ UI Update
    setItems((prev) => prev.filter((item) => item.id !== id));
  }

  function closeForm() {
    setEditId(null);
    setName("");
    setDesignation("");
    setFeedback("");
    setAvatarFile(null);
    setShowModal(false);
  }

  return (
    <div className="p-4">
      <div className="flex justify-between mb-4">
        <h2 className="text-xl font-bold">Testimonials</h2>
        <button
          className="bg-green-600 text-white px-4 py-2 rounded"
          onClick={() => setShowModal(true)}
        >
          + Add New
        </button>
      </div>

      <table className="border w-full text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2">Avatar</th>
            <th className="p-2">Name</th>
            <th className="p-2">Role</th>
            <th className="p-2">Feedback</th>
            <th className="p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item) => (
              <tr key={item.id} className="border text-center">
                <td className="p-2">
                  {item.avatar_url && (
                    <img
                      src={item.avatar_url}
                      className="w-12 h-12 object-cover rounded-full mx-auto"
                      alt=""
                    />
                  )}
                </td>
                <td className="p-2">{item.name}</td>
                <td className="p-2">{item.designation}</td>
                <td className="p-2 line-clamp-2">{item.feedback}</td>
                <td className="p-2 space-x-4">
                  <button
                    className="text-blue-600"
                    onClick={() => handleEdit(item)}
                  >
                    <FiEdit />
                  </button>
                  <button
                    className="text-red-600"
                    onClick={() => handleDelete(item.id, item.avatar_url)}
                  >
                    <FiTrash2 />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center p-4">
                No testimonials yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
          <div className="bg-white w-[450px] p-6 rounded-lg">
            <h3 className="font-bold mb-3">
              {editId ? "Edit Testimonial" : "Add Testimonial"}
            </h3>

            <input
              className="border p-2 w-full mb-2"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              className="border p-2 w-full mb-2"
              placeholder="Designation"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            />
            <textarea
              rows="4"
              className="border p-2 w-full mb-3"
              placeholder="Feedback"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            ></textarea>
            <input
              type="file"
              onChange={(e) => setAvatarFile(e.target.files[0])}
              className="mb-3"
            />

            <div className="flex justify-end gap-3">
              <button className="px-4 py-2 border rounded" onClick={closeForm}>
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-green-600 text-white rounded"
                onClick={handleSave}
              >
                {editId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
